import { render, staticRenderFns } from "./CsVideoReel.vue?vue&type=template&id=32d3600a&"
import script from "./CsVideoReel.vue?vue&type=script&lang=js&"
export * from "./CsVideoReel.vue?vue&type=script&lang=js&"
import style0 from "./CsVideoReel.vue?vue&type=style&index=0&id=32d3600a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports